module.exports = __webpack_public_path__ + "img/03新聞稿.58017201.jpg";